import { RootState } from "../";
import { FAVOURITES_ENUM } from "./types";

export function isFavourite(id: number, type: FAVOURITES_ENUM) {
  return (state: RootState): boolean => {
    const listName =
      type === FAVOURITES_ENUM.OPPORTUNITY ? "opportunities" : "organisations";

    return Object.keys(state.favourites[listName]).includes(`${id}`);
  };
}
